var exports = {
  "kL": "x9245d464--392dba--container",
  "$P": "x9245d464--392dba--search",
  "yP": "x9245d464--392dba--bottom--controls",
  "rZ": "x9245d464--392dba--category-header",
  "q9": "x9245d464--392dba--title-and-description",
  "sQ": "x9245d464--392dba--bottom",
};

module.exports = exports;
